export const ROUTES = {
  login: '/login',
  register: '/register',
  passwordSetup: '/password/setup',
  admissionCompanies: '/admission/companies',
  admissionWorkspace: '/admission/workspace',
  admissionProfileEdit: '/admission/profile/edit',
  sso: '/sso',
  supplier: {
    root: '/supplier',
    workbench: '/supplier/workbench',
    account: '/supplier/personal/account-management',
    informationManagement: '/supplier/personal/information-management',
    informationManagementEdit: '/supplier/personal/information-management/edit',
    uploads: '/supplier/system/uploads',
    downloads: '/supplier/system/downloads',
    qualityFeedback: '/supplier/quality-feedback',
    qualityCenterQAReports: '/supplier/quality-center/qa-inspection-reports',
    qualityCenterQAReportDetail: '/supplier/quality-center/qa-inspection-reports/:reportId',
    qualityCenterPatrolReports: '/supplier/quality-center/routing-inspect-reports',
    qualityCenterPatrolReportDetail: '/supplier/quality-center/routing-inspect-reports/:reportId',
    qualityCenterFeedback: '/supplier/quality-center/quality-feedback',
    // 已废弃：旧 master 版本的巡检实现仅保留源码兼容，不再注册正式路由或菜单。
    qualityCenterQARoutingInspectionReports: '/supplier/quality-center/qa-routing-inspection-reports',
    qualityCenterQARoutingInspectionReportDetail: '/supplier/quality-center/qa-routing-inspection-reports/:reportId',
    packingAndDelivery: '/supplier/orders/delivery/packing',
    packingBoxLabel: '/supplier/orders/delivery/packing/box-label',
    factoryExtensionApplications: '/supplier/orders/factory-extension-applications',
    preProductionSampleTasks: '/supplier/orders/pre-production-sample-tasks',
    productCatalog: '/supplier/products/catalog',
    productPatternFobTasks: '/supplier/products/pattern/fob-tasks',
    oemOdmWorkbench: '/supplier/products/pattern/oem-odm-tasks',
    oemOdmRecommendationNew: '/supplier/products/pattern/oem-odm-tasks/recommendations/new',
    oemOdmRecommendationEdit: '/supplier/products/pattern/oem-odm-tasks/recommendations/:recommendationId/edit',
    oemOdmProjectionDetail: '/supplier/products/pattern/oem-odm-tasks/recommendations/projections/:projectionId',
    notifications: '/supplier/notifications/list',
    productStockInventory: '/supplier/products/inventory/stock-up',
    reconciliationReceipts: '/supplier/reconciliation/receipts',
    reconciliationRewardsPenalties: '/supplier/reconciliation/rewards-penalties',
    reconciliationOverdue: '/supplier/reconciliation/overdue',
    reconciliationReturns: '/supplier/reconciliation/returns',
    reconciliationStatements: '/supplier/reconciliation/statements',
    materialMarket: '/supplier/product-operations/material-market',
    materialMarketList: '/supplier/product-operations/material-market/list',
    materialMarketDetail: '/supplier/product-operations/material-market/materials/:marketId',
  },
  demo: {
    root: '/demo',
    form: '/demo/form',
    table: '/demo/table',
    upload: '/demo/upload',
    print: '/demo/print',
    printEditor: '/demo/print/editor/:templateId',
    breadcrumb: '/demo/breadcrumb',
    feedback: '/demo/feedback',
    segmentedTabs: '/demo/segmented-tabs',
    workspaceTabs: '/demo/workspace-tabs',
    listStandard: '/demo/list/standard',
    listCompact: '/demo/list/compact',
  },
} as const
